import React from "react";
import "./labelErrorPure.css";

/**
 * @typedef {Object} Props
 * @property {String} label El texto que se mostrara como error
 * ```js
 * Ingresa un nombre válido.
 * @param {Props}
 * @return {JSX.Element} 
 */
const LabelErrorPure = ({label}) => {
    return ( 
        <div className="labelErrorPure-container">
            <p className="labelErrorPure-label">{label}</p>
        </div>
    )
}

export { LabelErrorPure as default }